import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const ApexTheme = definePreset(Aura, {
  primitive: {
    pink: {
      50: '#ffecfc', 100: '#fed8f8', 200: '#fdb0f0', 300: '#fb73df',
      400: '#f920ca', 500: '#99047e', 600: '#7c086b', 700: '#680457',
      800: '#4f0441', 900: '#450738', 950: '#2f0126'
    },
    indigo: {
      50: '#f2f3f9', 100: '#e1e5f3', 200: '#c8d0eb', 300: '#a3b0dc',
      400: '#788ac9', 500: '#4d5cb5', 600: '#484f9e', 700: '#494b91',
      800: '#3c3d71', 900: '#35365a', 950: '#232337'
    },
    blue: {
      50: '#edf3f9', 100: '#d4e2f2', 200: '#b3cce9', 300: '#7eacda',
      400: '#4180c5', 500: '#254471', 600: '#253961', 700: '#253253',
      800: '#212a44', 900: '#1a2030', 950: '#141720'
    },
    green: {
      50: '#e3fef2', 100: '#bffade', 200: '#81f4c3', 300: '#31e7a6',
      400: '#1aa476', 500: '#067a58', 600: '#006247', 700: '#00523e',
      800: '#013f2f', 900: '#023327', 950: '#011c17'
    },
    cyan: {
      50: '#f4fcfc', 100: '#e3f5f7', 200: '#cbeaee', 300: '#a8dce2',
      400: '#7fc5cf', 500: '#4eb6c6', 600: '#3c9aaf', 700: '#387e90',
      800: '#386977', 900: '#335866', 950: '#1c3944'
    },
    sky: { 
      50: '#f2f7fc', 100: '#e2ecf7', 200: '#ccdef1', 300: '#a9c9e7', 
      400: '#80adda', 500: '#598bcd', 600: '#4e78c2', 700: '#4366b2', 800: 
      '#3c5491', 900: '#344874', 950: '#242e47' 
    },
    purple: {
      50: '#f9f4fd', 100: '#efe7f9', 200: '#e2d5f3', 300: '#ccb3ea',
      400: '#ad82db', 500: '#7539b5', 600: '#663895', 700: '#563576',
      800: '#4a2f62', 900: '#3c274e', 950: '#271438'
    },
    red: {
      50: '#fdf0f1', 100: '#fbe2e2', 200: '#f7c8cb', 300: '#f09ba1',
      400: '#e76370', 500: '#c7263a', 600: '#902739', 700: '#831e32',
      800: '#6e1b2e', 900: '#5e1a2c', 950: '#350a14'
    },
    yellow: {
      50: '#fffae1', 100: '#fff5b1', 200: '#ffe667', 300: '#ffce10',
      400: '#ce9900', 500: '#b87d00', 600: '#9f5e00', 700: '#8b4800',
      800: '#683207', 900: '#582a0b', 950: '#341402'
    },
    orange: { 50: '#fff5ea', 100: '#fee9ce', 200: '#fdcf9e', 300: '#fbac60',
      400: '#f97c1f', 500: '#dd5a08', 600: '#b7420b', 700: '#a3340b',
      800: '#812a11', 900: '#682510', 950: '#381006'
    }
  },

  // 2) Semantic tokens – set your primary + surfaces
  semantic: {
    primary: {
      50: '{blue.50}', 100: '{blue.100}', 200: '{blue.200}', 300: '{blue.300}',
      400: '{blue.400}', 500: '{blue.500}', 600: '{blue.600}', 700: '{blue.700}',
      800: '{blue.800}', 900: '{blue.900}', 950: '{blue.950}'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#fafcfe', 50: '#f8fafc', 100: '#f1f5f9', 200: '#e2e8f0', 300: '#cbd5e1',
          400: '#94a3b8', 500: '#64748b', 600: '#4b5563', 700: '#334155', 800: '#1e293b',
          900: '#0f172a', 950: '#020617', 1000: '#000415'
        }
      },
      dark: {
        surface: {
          0: '#000415', 50: '#020617', 100: '#0f172a', 200: '#1e293b', 300: '#334155',
          400: '#4b5563', 500: '#64748b', 600: '#94a3b8', 700: '#cbd5e1', 800: '#e2e8f0',
          900: '#f1f5f9', 950: '#f8fafc', 1000: '#fafcfe'
        }
      }
    }

  },

  extend: {
    alpha: {
      pink: { a16: '#99047E29', a10: '#99047E1A' },
      indigo: { a16: '#4D5CB529', a10: '#4D5CB51A' },
      blue: { a16: '#25447129', a10: '#2544711A' },
      green: { a16: '#067A5829', a10: '#067A581A' },
      red: { a16: '#C7263A29', a10: '#C7263A1A' },
      yellow: { a16: '#B87D0029', a10: '#B87D001A' },
      orange: { a16: '#DD5A0829', a10: '#DD5A081A' }
    }
  },
  components: {
    progressspinner: {
      colorScheme: {
        light: {
          root: {
            colorOne: '{sky.500}',
            colorTwo: '{purple.500}',
            colorThree: '{pink.500}',
            colorFour: '{blue.500}'
          }
        },
        dark: {
          root: {
            colorOne: '{sky.500}',
            colorTwo: '{purple.500}',
            colorThree: '{pink.500}',
            colorFour: '{blue.500}'
          }
        }
      }
    }
  }
});

export default ApexTheme;
